<template>
    <div v-if="notificationBar.isVisible" :class="['bar-notification-optimization',$prefixClass.card+'-stroke', 'bar-notification-' + notificationBar.type]">
        <div class="notification__info">
            <div class="notification__icon all-center">
                <i class="fas fa-exclamation-circle"></i>
            </div>
            <div class="notification__content">
                <p class="notification__content__title">{{$t('optimize_image.notification_bar.'+ notificationBar.type +'.title')}}</p>
                <p class="text-color-secondary" v-html="$t('optimize_image.notification_bar.'+ notificationBar.type +'.content', {images: notificationBar.detail.total, number: formatSize(notificationBar.detail.total_saved)})"></p>
            </div>
        </div>
        <!-- <a-button type="primary" @click="handleOptimize">Optimize now</a-button> -->
    </div>
</template>

<script>
export default {
    name: 'BarNotificationOptimization',
    props:{
        value: {
            type: Object,
            required: true
        }
    },
    computed: {
        notificationBar: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', this.value)
            }
        }
    },

    data(){
        return {
        
        }
    },

    created() {
    },

    methods:{
        // handleOptimize() {
        //     this.$emit('optimize-now')
        // }
    }
}
</script>

<style lang="scss">
    .bar-notification-optimization {
        height: 80px;
        padding: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-color: $warning-color;
        .notification__icon {
            background-color: rgb(250 173 20 / 0.2);

            i {
                color: $warning-color;
            }
        }
        .notification__content {
            &__title {
                color: $warning-color;
            }
        }

        .notification__info {
            display: flex;
            align-items: center;
        }

        .notification__icon {
            width: 34px;
            height: 34px;
            border-radius: 50%;
            i {
                font-size: 22px;
            }
        }

        .notification__content {
            margin-left: 16px;
            &__title {
                font-weight: 600;
            }
            p {
                line-height: 24px;
                margin: 0;
            }
        }
    }
</style>